import { Box, styled } from "@mui/material";

export const ArchitectureTitle = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;
